import React from 'react'
import './TransitionAgencyVideoSection.component.scss'

const TransitionAgencyVideoSection = () => {
  return (
    <section className='transition-video-section'>
      <div className='transition-video-section__grid'>
        <div className='transition-video-section__text-col'>
          <h2 className='transition-video-section__heading'>A Strategic Path Forward</h2>
          <div className='transition-video-section__body'>
            <p>
              After years of building your book of business, relationships, and reputation &mdash; transitioning your
              agency is one of the most important decisions you&rsquo;ll make.
            </p>
            <p>
              USA Benefits Group partners with independent agents and agency owners nationwide to provide structured
              merger and acquisition opportunities that ensure continuity for clients while maximizing long-term value
              for the seller.
            </p>
          </div>
        </div>
        <div className='transition-video-section__video-col'>
          <iframe
            title='vimeo-player'
            src='https://player.vimeo.com/video/1135740716?h=359ae69e5f'
            width='640'
            height='360'
            frameBorder='0'
            referrerPolicy='strict-origin-when-cross-origin'
            allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
            allowFullScreen
          />
        </div>
      </div>
    </section>
  )
}

export default TransitionAgencyVideoSection
